import AwardsPage from './AwardsPage';
export default AwardsPage;
